import { svg } from '@phi/components';
import raw from './icon.inline.svg';

export const stl_file_icon = svg(raw);
